<template>
    <div class="footer hidden-print">
        <div class="container">
            <div class="row clearfix hidden-xs">
                <div class="footerpc">
                    <div class="col-xs-12 col-md-4 col-sm-5">
                        <!--国办纠错-->
                        <span class="error-icon" >
                            <span id="_span_jiucuo"  @click="openError">
                                <img onclick="Link('6101000007')" style="margin:0;border:0;cursor: pointer;" src="https://zfwzgl.www.gov.cn/exposure/images/jiucuo.png?v=6101000007">
                            </span>
					    </span>
                        <!--/国办纠错-->
                        <!--党政机关标识-->
                        <span class="gov-icon">
                            <!-- <script id="dangb" type="text/javascript">
                                document.write(
                                    unescape(
                                        "%3Cspan id='_ideConac' %3E%3C/span%3E%3Cscript src='http://dcs.conac.cn/js/27/386/0000/40918435/CA273860000409184350001.js' type='text/javascript'%3E%3C/script%3E"
                                    )
                                );
                            </script> -->
                            <span id="_ideConac"
                                ><a
                                    href="//bszs.conac.cn/sitename?method=show&amp;id=0A5537536EC43D83E053022819ACDDA0"
                                    target="_blank"
                                    ><img
                                        id="imgConac"
                                        vspace="0"
                                        hspace="0"
                                        border="0"
                                        src="//dcs.conac.cn/image/red.png"
                                        data-bd-imgshare-binded="1" /></a
                            ></span>
                            <!-- <script
                                src="http://dcs.conac.cn/js/27/386/0000/40918435/CA273860000409184350001.js"
                                type="text/javascript"
                            ></script> -->
                            <span id="_ideConac"></span>
                        </span>
                        <!--/党政机关标识-->
                    </div>
                    <div class="col-sm-7 col-md-8 col-xs-12 text ib">
                        <p>
                            <span>西安市人民政府办公厅主办</span>
                            <!-- <span>西安市人民政府办公厅承办</span> -->
                            <span class="linkWe">
                                <a
                                    target="_blank"
                                    href="http://www.xa.gov.cn/index/gywm/5d4feadefd85081f0f92c624.html"
                                    >关于我们</a
                                >|
                                <a
                                    target="_blank"
                                    href="http://www.xa.gov.cn/index/gywm/5d501154fd85081f0f92f129.html"
                                    >联系我们</a
                                >|
                                <a
                                    target="_blank"
                                    href="http://www.xa.gov.cn/index/gywm/5d501187f99d655a2e2e45bf.html"
                                    >网站声明</a
                                >|
                                <a href="http://www.xa.gov.cn/sitemap.html">网站地图</a>
                            </span>
                        </p>
                        <p>
                            <span>网站标识码：6101000007</span>
                            <span
                                ><a
                                    href="http://beian.miit.gov.cn/"
                                    target="_blank"
                                    >陕ICP备05011550号</a
                                ></span
                            >
                            <span
                                ><a
                                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61011202000087"
                                    target="_blank"
                                    ><img src="@/assets/images/ghs.png" />陕公网安备
                                    61011202000087号</a
                                ></span
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "foot",
    data() {
        return {};
    },
    methods:{
        openError(){
            window.open("https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=6101000007&url=http%3A%2F%2Fwww.xa.gov.cn%2Fhd%2F")
        }
    }
};
</script>

<style scoped>
@media (min-width: 992px) {
    .col-md-4 {
        width: 33.33333333%;
    }
}
@media (min-width: 768px) {
    .col-sm-5 {
        width: 30.66666667%;
    }
}
@media (min-width: 992px) {
    .col-md-8 {
        width: 66.66666667%;
    }
}
.col-sm-5{
    display: inline-block;
    text-align: right;
}
.footer {
    width: 100%;
    padding: 10px 0 0 0;
    text-align: left;
}
.footerpc {
    overflow: hidden;
    height: auto;
    padding: 0 20px 0;
}
.footerpc .gov-icon {
    /* float: right; */
    width: 80px;
    height: 80px;
    margin-right: 20px;
}
.footerpc .text {
    padding: 20px 15px 10px 15px;
}
.footerpc .text p {
    display: inline-block;
    margin: 0;
    line-height: 1.8;
}
.footerpc .text p span {
    float: left;
    display: inline-block;
    margin: 0 auto;
    padding: 0 10px;
    text-align: left;
    font-size: 14px;
    color: #222;
}
.linkWe {
    display: inline-block;
    margin: 0 auto;
    text-align: left;
}
.linkWe a {
    display: inline-block;
    padding: 0 8px;
    color: #000;
}
a {
    color: #333;
    text-decoration: none;
}
.ib{
    display: inline-block;
}
.footerpc .error-icon {
    /* float: right; */
    width: 110px;
    margin-right: 10px;
    padding-top: 12px;
}
</style>